module.exports = __webpack_public_path__ + "static/media/piggy-bank.2397457d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/piggy-bank.png
// module id = 879
// module chunks = 0